<template>
  <div id="detail">
    <div class="title">{{ data.title }}</div>
    <div class="info">
      <div>
        <h3>{{ data.subhead }}</h3>
        <!-- <div>
        <van-tag
          text-color="#fff"
          v-for="(item, index) in tagList"
          :color="colors[index]"
          :key="item"
          style="margin-right: 8px"
          >{{ item }}</van-tag
        >
      </div> -->
        <p>{{ data.publishTime }}</p>
      </div>
      <!-- <div class="icon">
        <button class="icon-box" @click="shouC()">
          <i
            class="iconfont"
            :class="isActive == true ? 'icon-yishoucang' : 'icon-shoucang'"
          ></i>
        </button>
        <button class="icon-box">
          <i class="iconfont icon-fenxiang"></i>
        </button>
      </div> -->
    </div>
    <div class="describe" v-if="data.describeHeadline">
      {{ data.describeHeadline }}
    </div>
    <div class="content">
      <div class="ql-editor" v-html="data.content" style="padding: 0"></div>
      <!-- <div class="icon">
        <button class="icon-box" @click="shouC()">
          <i
            class="iconfont"
            :class="isActive == true ? 'icon-yishoucang' : 'icon-shoucang'"
          ></i>
        </button>
        <button class="icon-box">
          <i class="iconfont icon-fenxiang"></i>
        </button>
      </div> -->
    </div>
    <van-skeleton title :row="24" v-if="isLoading" />
  </div>
</template>

<script>
import moment from "moment";
import { format } from "date-fns";

import "quill/dist/quill.snow.css";

let colors = [
  "#c23531",
  "#2f4554",
  "#61a0a8",
  "#d48265",
  "#91c7ae",
  "#749f83",
  "#ca8622",
  "#bda29a",
  "#6e7074",
  "#546570",
  "#c4ccd3",
];
import { tagData, zxDetail } from "@/api/zixun";
export default {
  data() {
    return {
      isActive: false,
      tagList: [],
      colors,
      data: {},
      isLoading: false,
      tagInfo: {},
    };
  },
  created() {
    this.getTagData();
    // this.getZxDetail();
  },
  methods: {
    // 收藏方法;
    shouC() {
      this.isActive = !this.isActive;
    },
    async getTagData() {
      try {
        let { data } = await tagData({
          pageModel: {
            size: 1000,
            current: 1,
          },
        });
        let tagInfo = {};
        data.tagVoList.forEach((item) => {
          tagInfo[item.id] = item.tagName;
        });
        this.tagInfo = tagInfo;
        this.getZxDetail();
      } catch (error) {}
      // axios
      //   .post(prefix + "/v1/app/infromation/tag/page", {
      //     pageModel: {
      //       size: 1000,
      //       current: 1,
      //     },
      //   })
      //   .then((data) => {
      //     let tagInfo = {};
      //     data.data.data.tagVoList.forEach((item) => {
      //       tagInfo[item.id] = item.tagName;
      //     });
      //     this.tagInfo = tagInfo;
      //     this.getZxDetail();
      //   });
    },

    async getZxDetail() {
      try {
        this.isLoading = true;
        const id = this.$route.query.id * 1;
        let { data } = await zxDetail({
          id: id,
        });
        console.log("获取图文详情：", data);
        this.isLoading = false;
        this.data = {
          title: data.informationHeadline,
          describeHeadline: data.describeHeadline,
          subhead: data.subhead,
          describeHeadline: data.describeHeadline,
          content: data.detailVo.infromationDetail,
          publishTime: format(data.publishDate, "yyyy.MM.dd"),
        };
        this.tagList = data.tags
          ? data.tags.split(",").map((item) => this.tagInfo[item])
          : [];
        console.log(this.tagList);
      } catch (error) {}
      // axios
      //   .get(prefix + "/v1/app/infromation/detail/getDetail?id=" + id)
      //   .then((res) => {
      //     console.log("获取图文详情：", res);
      //     this.isLoading = false;
      //     this.data = {
      //       title: res.data.data.informationHeadline,
      //       content: res.data.data.detailVo.infromationDetail,
      //       publishTime: moment(res.data.data.publishDate).format("MM/DD"),
      //     };
      //     this.tagList = res.data.data.tags
      //       ? res.data.data.tags.split(",").map((item) => this.tagInfo[item])
      //       : [];
      //   });
    },
  },
};
</script>

<style lang="less">
@import url("../../assets/styles/font.css");
.icon {
  text-align: right;
  // margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  .icon-box {
    width: 32px;
    height: 32px;
    background: #f4f8fd;
    border-radius: 6px;
    border: 0;
    outline: none;
    line-height: 32px;
    margin-left: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      font-size: 16px;
      color: #4b84ff;
    }
  }
}
.ql-editor {
  margin-bottom: 60px;
  ol{
    padding: 0;
  }
  ul{
    padding: 0;
  }
  h5 {
    line-height: 24px;
    color: #9095a7;
  }
  h4 {
    font-family: "Bold";
    font-size: 15PX;
    color: #4b84ff;
  }
  h3 {
    font-size: 15PX;
    position: relative;
    padding-left: 12px;
    color: #4b84ff;
    font-family: "Bold";
    &::before {
      content: "";
      position: absolute;
      width: 3px;
      height: 14px;
      background: #4b84ff;
      border-radius: 0px 2px 2px 0px;
      left: 0;
      top: 50%;
      margin-top: -7px;
    }
  }
  h2 {
    font-family: "Medium";
    background: #f4f8fd;
    height: auto;
    color: #4b84ff;
    text-align: center;
    font-size: 18PX;
    position: relative;
    padding: 14px 24px;
    &::before {
      content: "";
      position: absolute;
      transform: rotate(180deg);
      top: 0;
      right: 0;
      border-top: 10px solid #d3def8;
      border-right: 10px solid #d3def8;
      border-bottom: 10px solid #fff;
      border-left: 10px solid #fff;
      width: 0;
    }
  }
  p {
    font-size: 15PX;
    font-weight: 400;
    color: #2f354d;
    line-height: 30px;
  }
}
.describe {
  width: 100%;
  padding: 20px 24px;
  box-sizing: border-box;
  background: #f4f8fd;
  border-radius: 10px;
  margin-bottom: 40px;
  font-size: 13px;
  font-weight: 400;
  color: #5f697d;
  line-height: 24px;
}
#detail {
  padding: 20px;
  .ql-font-Gotham {
    font-family: "Gotham";
  }
  .ql-font-Bold {
    font-family: "Bold";
  }

  .ql-font-Medium {
    font-family: "Medium";
  }

  .ql-font-Regular {
    font-family: "Regular";
  }

  .ql-font-Light {
    font-family: "Light";
  }
  .title {
    font-size: 22px;
    font-weight: 500;
    color: #2f354d;
    text-align: left;
    margin-bottom: 14px;
  }
  .info {
    text-align: left;
    font-size: 14px;
    color: #aaa;
    margin-bottom: 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    div {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    p {
      font-size: 12px;
      font-weight: 400;
      color: #a4a9bf;
      line-height: 18PX;
    }
    h3 {
      color: #2f354d;
      font-size: 13px;
      font-weight: 400;
      color: #2f354d;
      line-height: 24px;
    }
  }
  .content {
    text-align: left;
    // font-family:"STXihei";
    font-size: 15PX;
    img {
      max-width: 100%;
    }
    .ql-editor .ql-video {
      display: block;
      width: 100% !important;
    }
    video {
      width: 100%;
    }
  }
}
</style>
